@if (crumbs || mobileCrumb) {
  <nav aria-label="Breadcrumbs" data-analytics="breadcrumbs">
    @if (deviceService.isTabletMdDown$ | async) {
      <div class="divider">
        @if (mobileCrumb) {
          <a #mobileLink sd-navigation-arrow [routerLink]="mobileCrumb.link">
            <span>{{ mobileCrumb.label }}</span>
          </a>
        }
      </div>
    } @else {
      @for (crumb of crumbs; track crumb; let i = $index) {
        @if (i !== crumbs.length) {
          <div class="divider">
            @if (i !== crumbs.length - 1) {
              <a [routerLink]="crumb.link">
                <span>{{ crumb.label }}</span>
              </a>
            } @else {
              <span>{{ crumb.label }}</span>
            }

            @if (i !== crumbs.length - 1) {
              <cx-icon [type]="iconType.ARROW_EXPAND"></cx-icon>
            }
          </div>
        }
      }
    }
  </nav>
}
